"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerTypes;
(function (CustomerTypes) {
    CustomerTypes["COMPANY"] = "Company";
    CustomerTypes["INDIVIDUAL"] = "Individual";
})(CustomerTypes = exports.CustomerTypes || (exports.CustomerTypes = {}));
